import React from "react";
import { History } from "history";
import { PlanoVinculadoEntidade, ContratoEntidade, ContratoDisponivel } from "../../../entidades";
import { MasterPage } from "../..";
import { IParametrosSimulacao } from ".";
import { NumFuncionalidade } from "../../MasterPage";
import { Box, CampoEstatico, TipoCampoEstatico, Row, Col, Botao, TipoBotao } from "@intechprev/componentes-web";
import { reCAPTCHA } from "../../../helpers";

interface IProps {
  history?: History;
}

interface IState {
  plano: PlanoVinculadoEntidade;
  emprestimos: Array<ContratoEntidade>;
  valorSolicitado: number;
  valorMargemConsignavel: number;
  saldoContratosAtivos: number;
  contrato: ContratoDisponivel;

  erro: string;
}

export class SimuladorEmprestimoResumo extends React.Component<IProps, IState> {
  private recaptcha = new reCAPTCHA("emprestimo_simulador_resumo");

  private page = React.createRef<MasterPage>();

  constructor(props: IProps) {
    super(props);

    const dados: IParametrosSimulacao = JSON.parse(localStorage.getItem("emprestimo-parametros"));
    const contrato: ContratoDisponivel = JSON.parse(localStorage.getItem("emprestimo-contrato-selecionado"));

    var recursoUtilizado = 0;

    if (dados.emprestimos.length > 0) {
      var indiceUltimaPrestacao = dados.emprestimos[0].Prestacoes.length - 1;
      recursoUtilizado = dados.emprestimos[0].Prestacoes[indiceUltimaPrestacao].VL_SALDO_ATUAL;
    }

    this.state = {
      plano: dados.plano,
      emprestimos: dados.emprestimos,
      valorSolicitado: dados.valorSolicitado,
      valorMargemConsignavel: dados.valorMargemConsignavel,
      saldoContratosAtivos: recursoUtilizado,
      contrato,

      erro: null,
    };
  }

  componentDidMount = async () => {
    try {
      await this.page.current.alternarLoading();

      await this.page.current.alternarLoading();
    } catch (error) {
      await this.setState({
        erro: error.response ? error.response.data : error,
      });

      await this.page.current.alternarLoading();
    }
  };

  render() {
    return (
      <MasterPage {...this.props} Funcionalidade={NumFuncionalidade.EMPRESTIMOS_SIMULAÇÃO} ref={this.page}>
        <h3>Bem-Vindo ao Simulador de Empréstimos da PREVIRB!</h3>
        <h5>Ao final da sua simulação você poderá realizar o requerimento do seu empréstimo diretamente por aqui, de forma on-line e segura!</h5>

        <Row>
          <Col>
            <Box titulo={"Resumo dos Cálculos"}>
              <CampoEstatico titulo={"Plano"} valor={this.state.plano.DS_PLANO} tamanhoTitulo={"md-4"} />
              <CampoEstatico titulo={"Modalidade do Empréstimo"} valor={this.state.contrato.Modalidade.DS_MODAL} tamanhoTitulo={"md-4"} />
              <CampoEstatico
                titulo={"Saldo Devedor"}
                valor={this.state.saldoContratosAtivos}
                tipo={TipoCampoEstatico.dinheiro}
                tamanhoTitulo={"md-4"}
              />
              <CampoEstatico
                titulo={"Valor Solicitado"}
                valor={this.state.valorSolicitado}
                tipo={TipoCampoEstatico.dinheiro}
                tamanhoTitulo={"md-4"}
              />
              <CampoEstatico
                titulo={"Total de Encargos/Tributos*"}
                valor={this.state.contrato.ValorTaxaAdministracao + this.state.contrato.ValorTaxaInadimplencia + this.state.contrato.ValorIOF}
                tipo={TipoCampoEstatico.dinheiro}
                tamanhoTitulo={"md-4"}
              />
              <b>
                <CampoEstatico
                  titulo={"Valor Líquido"}
                  valor={this.state.contrato.ValorLiquido}
                  tipo={TipoCampoEstatico.dinheiro}
                  tamanhoTitulo={"md-4"}
                />
              </b>
              <CampoEstatico titulo={"Data de Crédito"} valor={this.state.contrato.DataCredito} tamanhoTitulo={"md-4"} />

              <h4 className={"mt-5"}>Resumo dos Cálculos</h4>
              <CampoEstatico titulo={"Prazo"} valor={`${this.state.contrato.Prazo} Meses`} tamanhoTitulo={"md-4"} />
              <CampoEstatico titulo={"Taxa"} valor={this.state.contrato.TaxaJuros} tipo={TipoCampoEstatico.percentual} tamanhoTitulo={"md-4"} />
              <CampoEstatico
                titulo={"Primeira Prestação"}
                valor={this.state.contrato.ValorPrestacao}
                tipo={TipoCampoEstatico.dinheiro}
                tamanhoTitulo={"md-4"}
              />

              <div className={"mt-5"}>
                <Botao titulo={"Voltar"} tipo={TipoBotao.light} onClick={() => this.props.history.goBack()} icone={"fas fa-chevron-left"} />

                <Botao
                  titulo={"Gostei! Quero Solicitar esse Empréstimo!"}
                  className={"ml-2"}
                  onClick={() => this.props.history.push("/simuladorEmprestimoContratacao")}
                  icone={"fas fa-chevron-right"}
                  iconeDireita
                  submit
                />
              </div>
            </Box>
          </Col>

          <Col>
            <Box titulo={"* Encargos/Tributos Calculados"}>
              <table className={"table table-sm"}>
                <thead>
                  <tr>
                    <th>Encargo/Tributo</th>
                    <th className={"text-right"}>Taxa</th>
                    <th className={"text-right"}>Valor</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>TAXA DE ADMINISTRAÇÃO</td>
                    <td className={"text-right"}>
                      <CampoEstatico valor={this.state.contrato.TaxaEncargo.TX_ADM} tipo={TipoCampoEstatico.percentual} />
                    </td>
                    <td className={"text-right"}>
                      <CampoEstatico valor={this.state.contrato.ValorTaxaAdministracao} tipo={TipoCampoEstatico.dinheiro} />
                    </td>
                  </tr>
                  <tr>
                    <td>TGE - TAXA DE GARANTIA DE EMPRÉSTIMO</td>
                    <td className={"text-right"}>
                      <CampoEstatico valor={this.state.contrato.TaxaEncargo.TX_INAD} tipo={TipoCampoEstatico.percentual} />
                    </td>
                    <td className={"text-right"}>
                      <CampoEstatico valor={this.state.contrato.ValorTaxaInadimplencia} tipo={TipoCampoEstatico.dinheiro} />
                    </td>
                  </tr>
                  <tr>
                    <td>IOF</td>
                    <td className={"text-right"}>
                      <CampoEstatico valor={this.state.contrato.TaxaEncargo.TX_IOF} tipo={TipoCampoEstatico.percentual} />
                    </td>
                    <td className={"text-right"}>
                      <CampoEstatico valor={this.state.contrato.ValorIOF} tipo={TipoCampoEstatico.dinheiro} />
                    </td>
                  </tr>
                </tbody>
              </table>
            </Box>
          </Col>
        </Row>
      </MasterPage>
    );
  }
}
